import { render, staticRenderFns } from "./InstagramNativeModal.vue?vue&type=template&id=6c662c1d&scoped=true&"
import script from "./InstagramNativeModal.vue?vue&type=script&lang=js&"
export * from "./InstagramNativeModal.vue?vue&type=script&lang=js&"
import style0 from "./InstagramNativeModal.vue?vue&type=style&index=0&id=6c662c1d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c662c1d",
  null
  
)

export default component.exports